import { ApiResponse, AttributeDefRow, AttributeDefRowNoId, AttributeDefRowView, User } from "@bonusmap/api-types";
import { templateParseToElement } from "../../logic/templateParse.js";
import { StepsComponent } from "../base-components/steps-component.js";
import { showConfirm } from "../../modals.js";
import { FormComponent } from "../form-component/form-component.js";
import { isNumber } from "@bonusmap/shared_ui/library";
import { createChoicesInstance } from "../../utils/createChoicesInstance.js";
const { Choices } = window;
export class AttributesComponent extends StepsComponent {
    static webComponentName: string = "attributes-input";
    static observedAttributes = ['data-attribute'];
    protected _templateId: string = "form-attributes-input";
    protected _step: string = 'attributes-view'; // Default step is the list of attributes
    private panelList!: HTMLDivElement;
    private attributesView!: HTMLElement;
    private addAttributeBtn!: HTMLButtonElement;
    private editAttributeBtn!: HTMLButtonElement;
    private removeAttributeBtn!: HTMLButtonElement;
    private listSelect!: HTMLSelectElement;
    // private attributesForm!: HTMLFormElement;
    private attributesForm!: FormComponent;
    private choicesInstance!: InstanceType<Window['Choices']>; // Choice.js instance
    private _value: string = "";
    private attributesCache: Record<number, AttributeDefRowView> = {}; // Cache degli oggetti scaricati dal server
    get readOnly(): boolean {
        return this.hasAttribute('readonly') || this.hasAttribute('disabled');
    }
    get compact(): boolean {
        return this.hasAttribute('compact');
    }
    get value(): string {
        return this._value;
    }
    private set value(newValue: string) {
        if (newValue && !isNumber(newValue)) {
            return; // Prevent setting non-numeric values
        }
        this._value = newValue;
        this.valueChanged(newValue);
        this.setAttribute('value', newValue.toString());
    }
    get current(): AttributeDefRowView | null {
        if (!this.value || !isNumber(this.value)) {
            return null; // No valid value set
        }
        const cached = this.getCached(this.value);
        if (cached) {
            return cached; // Return from cache if available
        }
        return null;
    }


    protected valueChanged(newValue: string): void {
        // Dispatch event to notify of value change
        this.dispatch('value-changed', {
            value: newValue
        });
        if (this.editAttributeBtn && this.current) {
            this.editAttributeBtn.classList.toggle('d-none', !newValue ||
                (this.current.is_core && !this.isAdmin));
        }
        if (this.removeAttributeBtn && this.current) {
            this.removeAttributeBtn.classList.toggle('d-none', !newValue ||
                (this.current.is_core && !this.isAdmin));
        }
        if (newValue == "") {
            this.editAttributeBtn?.classList.add('d-none');
            this.removeAttributeBtn?.classList.add('d-none');
        }
    }
    constructor() {
        super();
        this.globalEventListeners();
    }
    protected renderForm(action: 'add' | 'edit'): void {
        if (action === 'add') {
            if (this.attributesForm) {
                this.attributesForm.dataset.action = 'add'; // Set action to add
            }
            this.clearForm(); // Clear the form when entering the attributes form step
        }
        else if (action === 'edit') {
            if (!this.current) {
                console.warn('Nessun attributo selezionato per la modifica');
                return;
            }
            this.clearForm();
            if (this.current && this.attributesForm) {
                this.attributesForm.dataset.action = 'edit';
                this.roleElementSelector('attributes-form-title')!.textContent = 'Modifica Attributo'; //  titolo del form
                // Pre-populate the form with the current attribute data
                const idInput = this.attributesForm.querySelector('[name="id"]') as HTMLInputElement;
                const nameInput = this.attributesForm.querySelector('[name="name"]') as HTMLInputElement;
                const descriptionTextarea = this.attributesForm.querySelector('[name="description"]') as HTMLTextAreaElement;
                const typeSelect = this.attributesForm.querySelector('[name="type_value"]') as HTMLSelectElement;
                const organizationInput = this.attributesForm.querySelector('[name="organization_id"]') as HTMLInputElement | HTMLSelectElement;
                if (idInput) idInput.value = this.current.id.toString();
                if (nameInput) nameInput.value = this.current.name || '';
                if (descriptionTextarea) descriptionTextarea.value = this.current.description || '';
                if (typeSelect) {
                    typeSelect.value = this.current.type_value || '';
                    typeSelect.disabled = true;
                }
                if (organizationInput) {
                    if (organizationInput.tagName === 'SELECT') {
                        (organizationInput as HTMLSelectElement).value = this.current.organization_id?.toString() || '0';
                    } else {
                        (organizationInput as HTMLInputElement).value = this.current.organization_id?.toString() || '';
                    }
                    organizationInput.disabled = true; // Disable organization selection for editing
                }
            }
        }
    }
    private globalEventListeners(): void {
        this.addEventListener('before-step-changed', (event: Event) => {
            const { step, target } = (event as CustomEvent).detail;
            if (step === 'attributes-form') {
                if (target === this.addAttributeBtn) {
                    this.renderForm('add');
                    // if (this.attributesForm) {
                    //     this.attributesForm.dataset.action = 'add'; // Set action to add
                    // }
                    // this.clearForm(); // Clear the form when entering the attributes form step
                }
                else if (target === this.editAttributeBtn) {
                    this.renderForm('edit');
                    // if (!this.current) {
                    //     console.warn('Nessun attributo selezionato per la modifica');
                    //     return;
                    // }
                    // this.clearForm();
                    // if (this.current && this.attributesForm) {
                    //     this.attributesForm.dataset.action = 'edit';
                    //     this.roleElementSelector('attributes-form-title')!.textContent = 'Modifica Attributo'; //  titolo del form
                    //     // Pre-populate the form with the current attribute data
                    //     const idInput = this.attributesForm.querySelector('[name="id"]') as HTMLInputElement;
                    //     const nameInput = this.attributesForm.querySelector('[name="name"]') as HTMLInputElement;
                    //     const descriptionTextarea = this.attributesForm.querySelector('[name="description"]') as HTMLTextAreaElement;
                    //     const typeSelect = this.attributesForm.querySelector('[name="type_value"]') as HTMLSelectElement;
                    //     const organizationInput = this.attributesForm.querySelector('[name="organization_id"]') as HTMLInputElement | HTMLSelectElement;
                    //     if (idInput) idInput.value = this.current.id.toString();
                    //     if (nameInput) nameInput.value = this.current.name || '';
                    //     if (descriptionTextarea) descriptionTextarea.value = this.current.description || '';
                    //     if (typeSelect) {
                    //         typeSelect.value = this.current.type_value || '';
                    //         typeSelect.disabled = true;
                    //     }
                    //     if (organizationInput) {
                    //         if (organizationInput.tagName === 'SELECT') {
                    //             (organizationInput as HTMLSelectElement).value = this.current.organization_id?.toString() || '0';
                    //         } else {
                    //             (organizationInput as HTMLInputElement).value = this.current.organization_id?.toString() || '';
                    //         }
                    //         organizationInput.disabled = true; // Disable organization selection for editing
                    //     }
                    // }
                }
            }
        });
        this.addEventListener('value-changed', (event: Event) => {
            this.renderProcessView(); // Render the current attribute view
        });
    }

    private processAttributeValue(): void {
        const attributeValue = this.getAttribute('value');
        if (!attributeValue) {
            console.warn('Nessun ID attributo specificato, non posso processare il valore');
            return;
        }
      
        this.addAttributeToChoicesById(attributeValue)
            .then(() => {
                this.value = attributeValue; // Set the value after adding to choices
            })
    }
    private getCached(id: number | string): AttributeDefRowView | null {
        if (!id || !isNumber(id as string)) {
            console.warn('ID attributo non specificato, non posso cercare nella cache');
            return null;
        }
        const numId = parseInt(id as string, 10);
        return this.attributesCache[numId] || null;
    }

    private async getAttributeById(id: number | string): Promise<AttributeDefRowView | null> {
        try {
            const response = await window.api.manager.personalAttributes.getById(parseInt(id as string, 10));
            if (response.success) {
                return response.data as AttributeDefRowView;
            } else {
                console.error('Error fetching attribute by ID:', response.error);
                return null;
            }
        } catch (error) {
            console.error('Error in getAttributeById:', error);
            return null;
        }
    }
    protected renderProcessView(): void {
        const attribute = this.current;
        if (!this.attributesView) {
            this.attributesView = this.roleElementSelector('attributes-view') as HTMLElement;
        }
        if (!this.attributesView) {
            console.warn('Elemento attributes-view non trovato, impossibile renderizzare la vista');
            return;
        }
        this.attributesView.innerHTML = ''; // Clear previous content

        let data = {
            readOnly: this.readOnly,
            compact: this.compact
        };
        if (attribute) {
            data = {
                ...data,
                ...attribute
            }
        }
        
        templateParseToElement(
            `form-attributes-input-view${this.compact ? '-compact' : ''}`,
            this.attributesView,
            data);


    }
    private async addAttributeToChoicesById(id: number | string): Promise<boolean> {
        const attribute = await this.getAttributeById(id);
        if (!attribute) {
            return false;
        }

        // Aggiungo l'attributo alla cache
        this.attributesCache[attribute.id] = attribute;

        const choice = {
            value: attribute.id.toString(),
            label: attribute.name,
            selected: true,
            customProperties: {
                description: attribute.description || '',
                type_value: attribute.type_value,
                organization_id: attribute.organization_id || 0,
                organization_name: attribute.organization_name || '',
                is_core: attribute.is_core || attribute.organization_id === 0,
            }
        };

        this.choicesInstance.setChoices([choice], 'value', 'label', false);
        return true;
    }
    private async performSearch(searchTerm: string): Promise<void> {
        if (!searchTerm || searchTerm.length == 0) {
            this.choicesInstance.clearChoices();
        }
        try {
            // const whereClause = `name ILIKE $1 OR description ILIKE $1`;
            // const params = [`%${searchTerm}%`];
            let whereClause = searchTerm && searchTerm.length > 0
                ? `name ILIKE $1 OR description ILIKE $2`
                : `1=1`; // Cerca tutti gli elementi se non c'è termine di ricerca
            let params = searchTerm && searchTerm.length > 0
                ? [`${searchTerm}%`,`%${searchTerm}%`]
                : [];
            const orderBy = 'name ASC';
            const limit = 20; // Limit results to 20 for performance
            const result = await window.api.manager.personalAttributes.query(whereClause, params, orderBy, limit);
            if (result.data && result.data.length > 0) {
                // Aggiungo tutti i nuovi oggetti alla cache
                result.data.forEach((item: AttributeDefRowView) => {
                    this.attributesCache[item.id] = item;
                });

                const choices = result.data.map((item: AttributeDefRowView) => {
                    return {
                        value: item.id.toString(),
                        label: item.name,
                        customProperties: {
                            description: item.description || '',
                            type_value: item.type_value,
                            organization_id: item.organization_id || 0,
                            organization_name: item.organization_name || '',
                            is_core: item.is_core || item.organization_id === 0,
                        }
                    };
                });
                this.choicesInstance.setChoices(choices, 'value', 'label', true);
            }
            else {
                this.choicesInstance.clearChoices();
            }
        } catch (error) {
            console.error('Error during search:', error);
            this.choicesInstance.clearChoices();
            return;

        }
    }
    private initializeChoices(): void {
        this.choicesInstance = createChoicesInstance(this.listSelect, {
            searchEnabled: true,
            removeItemButton: true,
            noResultsText: 'Nessun attributo trovato',
            searchPlaceholderValue: 'Digita per cercare attributi...',
            maxItemCount: 20,
            // Personalizzazione template items nei risultati di ricerca
            callbackOnCreateTemplates: (template) => {
                return {
                    choice: (classNames, choice, selectText, groupName) => {
                        return this.createCustomChoiceTemplate(template, classNames, choice, selectText, groupName);
                    }
                };
            }
        });
        this.listSelect.addEventListener('search', (event: any) => {
            const searchTerm = event.detail.value;
            this.performSearch(searchTerm);
        });
        this.listSelect.addEventListener('showDropdown', (event: any) => {
            // Carica i dati iniziali al focus se il dropdown è vuoto
            const searchTerm = this.choicesInstance.input?.value || '';
            this.performSearch(searchTerm);
            console.log("showDropdown event",this);
        });
        this.listSelect.addEventListener('addItem', (event: any) => {
            const id = event.detail.value;
            const cached = this.getCached(id);
            if (cached) {
                this.value = cached.id.toString(); // Set the value to the ID of the added attribute
            }

        });
        this.listSelect.addEventListener('removeItem', (event: any) => {
            this.value = ''; // Clear the value when an item is removed
        });
    }

    /**
     * Crea un template personalizzato per gli items nei risultati di ricerca
     * Utilizza templateParseToElement per renderizzare il template Nunjucks
     */
    private createCustomChoiceTemplate(template: any, classNames: any, choice: any, selectText: string, groupName?: string): HTMLDivElement {
        // choice è un oggetto ChoiceFull di Choices.js
        // I miei dati da performSearch sono in choice.customProperties
        const templateData = {
            // Dati di base da Choices.js (ChoiceFull interface)
            id: choice.id,
            value: choice.value,
            label: choice.label,
            selectText: selectText,
            group: choice.group,
            disabled: choice.disabled,

            // I miei dati sono in customProperties (da performSearch:28-37)
            customProperties: choice.customProperties || {},
            // Dati computati per il template
            typeDisplayName: this.getTypeDisplayName(choice.customProperties?.type_value),
        };
        // Uso templateParseToElement per renderizzare il template
        const customDiv = document.createElement('div');
        templateParseToElement('form-attributes-input-item-search', customDiv, templateData);

        if (!customDiv.hasChildNodes()) {
            // Fallback al template di default di Choices.js se il nostro template non funziona
            console.warn('Template personalizzato non trovato, uso il default di Choices.js');
            return template.choice(classNames, choice, selectText, groupName);
        }


        // Aggiungo le classi CSS richieste da Choices.js
        const { item, itemChoice, itemSelectable, selectedState, itemDisabled, placeholder } = classNames.classNames;

        customDiv.classList.add(...item, ...itemChoice);
        customDiv.id = choice.elementId;

        // Gestione stati Choices.js
        if (choice.selected) {
            customDiv.classList.add(...selectedState);
        }

        if (choice.placeholder) {
            customDiv.classList.add(...placeholder);
        }

        if (choice.disabled) {
            customDiv.classList.add(...itemDisabled);
        } else {
            customDiv.classList.add(...itemSelectable);
        }

        return customDiv;
    }
    protected buildRenderingData(): Record<string, any> {
        const user = this.user;
        let organization_id = user.organization_id || 0; // Default to 0 if not set
        let organizations: any[] = [];
        if (user.impersonation) {
            organizations = [
                {
                    id: user.organization_id,
                    name: user.organization_name || 'Organizzazione Originale'
                },
                {
                    id: user.impersonation.id,
                    name: user.impersonation.name || 'Organizzazione Impersonata'
                }
            ]
        }
        const data = {
            organization_id,
            organization_name: user.organization_name || '',
            role: user.role,
            isAdmin: this.isAdmin,
            isEdit: this.isEdit,
            organizations,
            is_core: organization_id === 0, // Attributo di sistema se organization_id è 0
        };
        return data;
    }
    /**
     * Restituisce il nome display per il tipo di attributo
     */
    private getTypeDisplayName(typeValue: string): string {
        const typeMap: Record<string, string> = {
            'number': 'Numero',
            'boolean': 'Sì/No',
            'date': 'Data',
        };
        return typeMap[typeValue] || typeValue;
    }

    private formSubmitHandler(event: Event): void {
        event.preventDefault();
        if (this.attributesForm.checkValidity() === false) {
            console.warn('Form non valido, verifica i campi richiesti');
            this.attributesForm.reportValidity();
            return;
        }
        const data = this.getFormData();
        const action = this.attributesForm.dataset.action || 'add';
        if (action !== 'add' && action !== 'edit') {
            console.error('Azione del form non valida:', action);
            return;
        }
        const { name, description = "", type_value } = data;
        const { organization_id } = data;
        let payload: AttributeDefRowNoId | AttributeDefRow = {
            organization_id: parseInt(organization_id, 10) || 0, // Default to 0 if not set
            name,
            description,
            type_value,
            attribute_data: {
                name,
                description,
                type_value
            },
            is_core: parseInt(organization_id, 10) === 0, // Attributo di sistema se organization_id è 0
            metadata: {},
        }
        try {
            if (action === 'edit') {
                const id = parseInt(data.id, 10);
                if (!isNumber(id)) {
                    console.error('ID non valido per l\'azione di modifica');
                    return;
                }
                (payload as AttributeDefRow).id = id; // Aggiungo l'ID per l'azione di modifica
            }
            const method = action === 'add' ? 'add' : 'update';
            window.api.manager.personalAttributes
            [method]((payload as any))
                .then((result: ApiResponse<{ id: number }>) => {
                    if (!result.success) {
                        console.log('payload:', payload);
                        console.error(result.error);
                        return;
                    }
                    else {
                        console.log('Azione completata con successo:', result.data);
                        const id = result.data?.id;
                        if (id) {
                            this.addAttributeToChoicesById(id);
                        }
                        this.afterSave();                        
                    }

                });
        } catch (error) {

        }
    }
    protected afterSave () : void {
        this.step = 'attributes-list'; // Torno alla lista dopo l'aggiunta
    }
    private removeCurrentAttribute(): void {
        if (!this.current) {
            return;
        }
        showConfirm("Sei sicuro di voler rimuovere questo attributo?", {
        })
            .then((confirmed) => {
                if (!confirmed || !this.current?.id) {
                    return;
                }
                window.api.manager.personalAttributes.delete(this.current.id)
                    .then((result: ApiResponse<AttributeDefRow | null>) => {
                        if (result.success) {
                            this.value = ''; // Reset the value after removal
                            this.choicesInstance.removeActiveItems(); // Remove the item from Choices.js
                            this.choicesInstance.clearChoices();
                        } else {
                            console.error('Errore durante la rimozione dell\'attributo:', result.error);
                        }
                    });
            });
    }
    private getFormData(): Record<string, any> {
        // const formData = new FormData(this.attributesForm);
        const data: Record<string, any> = this.attributesForm.getFormData();

        // FormData ignora i campi disabled, li aggiungo manualmente
        const allInputs = this.attributesForm.querySelectorAll('input, select, textarea');
        allInputs.forEach((input: Element) => {
            if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement) {
                if (input.name && input.disabled) {
                    data[input.name] = input.value;
                }
            }
        });
        data['organization_id'] = data['organization_id'] ? parseInt(data['organization_id'] as string, 10) : 999;
        return data;
    }

    private clearForm(): void {
        if (!this.attributesForm) {
            console.warn('Form attributes non trovata, impossibile svuotarla');
            return;
        }

        // Reset di tutti i campi del form
        this.attributesForm.reset();
        // riabilito i campi disabilitati
        const inputs = this.attributesForm.querySelectorAll('input, select, textarea');
        inputs.forEach((input: Element) => {
            if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement) {
                input.disabled = false; // Riabilito i campi
            }
        });
        this.roleElementSelector('attributes-form-title')!.textContent = 'Aggiungi Nuovo Attributo'; // Reset del titolo del form
    }

    protected afterRender(): void {
        super.afterRender();
        // Inizializzo i componenti specifici di questo web component
        this.panelList = this.roleElementSelector('attributes-list') as HTMLDivElement;
        this.attributesView = this.roleElementSelector('attributes-view') as HTMLElement;
        this.listSelect = this.roleElementSelector('attributes-select') as HTMLSelectElement;
        this.editAttributeBtn = this.roleElementSelector('edit-attribute-btn') as HTMLButtonElement;
        this.addAttributeBtn = this.roleElementSelector('add-attribute-btn') as HTMLButtonElement;
        this.removeAttributeBtn = this.roleElementSelector('remove-attribute-btn') as HTMLButtonElement;
        this.initializeChoices();
        

        this.removeAttributeBtn?.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();
            this.removeCurrentAttribute();
        });
        this.attributesForm = this.roleElementSelector('attributes-form') as FormComponent;
        console.log('call processAttributeValue');
        this.processAttributeValue(); // Process the initial attribute value if set
        console.log(`call renderProcessView`);
        this.renderProcessView();
        setTimeout(() => {
            
            this.attributesForm.addEventListener('submit', this.formSubmitHandler.bind(this));
        }, 500); // Use setTimeout to ensure it runs after the DOM is updated
    }
    protected render(): void {
        const user = this.user;
        if (!user) {
            this.onRenderError('User not found');
            return; // Prevent rendering if user is not available
        }
        super.render();
    }

}